import { createSlice } from "@reduxjs/toolkit";
import {
  AddPersonalityAction,
  DeletePersonalityAction,
  GetAllPersonalityAction,
  UpdatePersonalityAction,
} from "store/middlewares/dataManagement/personality";

// isDeleteMeFulFilled
export const personalitySlice = createSlice({
  name: "personality",
  initialState: {
    personalityLoading: true,
    personality: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllPersonalityAction.pending, (state) => {
        // state.personalityLoading = true;
        // state.personality = null;
        state.personality =
          state.personality?.data?.length > 0 ? state.personality : null;
      })
      .addCase(GetAllPersonalityAction.fulfilled, (state, action) => {
        state.personalityLoading = false;
        state.personality = action.payload.response;
      })
      .addCase(GetAllPersonalityAction.rejected, (state) => {
        state.personalityLoading = false;
        state.personality = null;
      })
      // Delete
      .addCase(DeletePersonalityAction.fulfilled, (state, action) => {
        // state.personalityLoading = false;
        // state.personality = {
        //   ...state.personality,
        //   total: Number(state.personality.total) - 1,
        //   data: state.personality?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.personalityLoading = false;
        state.personality = action.payload.response;
      })
      //Update
      .addCase(UpdatePersonalityAction.fulfilled, (state, action) => {
        state.personalityLoading = false;
        state.personality = {
          ...state.personality,
          data: state.personality.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddPersonalityAction.fulfilled, (state, action) => {
        // state.personalityLoading = false;
        // state.personality = {
        //   ...state.personality,
        //   total: Number(state.personality.total) + 1,
        //   data: [action.payload.response, ...state.personality.data],
        // };
        state.personalityLoading = false;
        state.personality = action.payload.response;
      });
  },
});

export default personalitySlice.reducer;
